<div class="ticket-details-page">
  <app-header></app-header>

  <div class="ticket-details-container">
    <div class="ticket-details-header">
      <button class="back-btn" (click)="goBack()">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
        <span>Back to Tickets</span>
      </button>
    </div>

    <div class="alert-container" *ngIf="successMessage || errorMessage">
      <div class="alert success" *ngIf="successMessage">
        <div class="alert-content">
          <div class="alert-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <span>{{ successMessage }}</span>
        </div>
        <button class="alert-close" (click)="clearMessages()">×</button>
      </div>
      <div class="alert error" *ngIf="errorMessage">
        <div class="alert-content">
          <div class="alert-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <span>{{ errorMessage }}</span>
        </div>
        <button class="alert-close" (click)="clearMessages()">×</button>
      </div>
    </div>

    <div class="ticket-content" *ngIf="!isLoading && ticketDetails">
      <div class="ticket-info-card">
        <div class="ticket-info-header">
          <div class="ticket-title-section">
            <div class="ticket-title">
              <span class="ticket-icon">{{
                getTicketIcon(ticketDetails.ticket.status)
              }}</span>
              <h1>{{ ticketDetails.ticket.subject || "No Subject" }}</h1>
            </div>
            <div class="ticket-meta">
              <span class="ticket-id"
                >Ticket ID: {{ ticketDetails.ticket.id.substring(0, 8) }}</span
              >
              <span class="ticket-created"
                >Created:
                {{ formatFullDate(ticketDetails.ticket.created_at) }}</span
              >
            </div>
          </div>
          <div class="ticket-status-section">
            <span
              class="ticket-status"
              [ngClass]="getStatusClass(ticketDetails.ticket.status)"
            >
              {{ formatStatus(ticketDetails.ticket.status) }}
            </span>
            <span
              class="ticket-priority"
              [ngClass]="getPriorityClass(ticketDetails.ticket.priority)"
            >
              {{ formatPriority(ticketDetails.ticket.priority) }}
            </span>
          </div>
        </div>

        <div class="original-message">
          <h3>Original Message</h3>
          <div class="message-content">
            <p>{{ ticketDetails.ticket.message }}</p>
          </div>
          <div class="message-author">
            <span
              >{{ ticketDetails.ticket.name }} ({{
                ticketDetails.ticket.email
              }})</span
            >
            <span class="message-date">{{
              formatFullDate(ticketDetails.ticket.created_at)
            }}</span>
          </div>
        </div>
      </div>

      <div class="conversation-section">
        <div class="conversation-header">
          <h2>Conversation</h2>
          <span class="response-count"
            >{{ ticketDetails.responses.length }} response(s)</span
          >
        </div>

        <div
          class="conversation-timeline"
          *ngIf="ticketDetails.responses.length > 0"
        >
          <div
            class="conversation-message"
            *ngFor="
              let response of ticketDetails.responses;
              trackBy: trackByResponseId
            "
            [ngClass]="{
              'admin-message': isAdminResponse(response),
              'user-message': isUserResponse(response)
            }"
          >
            <div class="message-avatar">
              <div
                class="avatar-circle"
                [ngClass]="{
                  'admin-avatar': isAdminResponse(response),
                  'user-avatar': isUserResponse(response)
                }"
              >
                <span *ngIf="isAdminResponse(response)">🛡️</span>
                <span *ngIf="isUserResponse(response)">👤</span>
              </div>
            </div>
            <div class="message-content">
              <div class="message-header">
                <span class="message-author">{{
                  getResponseAuthor(response)
                }}</span>
                <span class="message-timestamp">{{
                  formatFullDate(response.created_at)
                }}</span>
              </div>
              <div class="message-body">
                <p>{{ getResponseText(response) }}</p>
              </div>
              <div
                class="message-meta"
                *ngIf="isAdminResponse(response) && response.email_subject"
              >
                <span class="email-subject"
                  >Email Subject: {{ response.email_subject }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="no-responses" *ngIf="ticketDetails.responses.length === 0">
          <div class="no-responses-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
              ></path>
            </svg>
          </div>
          <h3>No responses yet</h3>
          <p>Our support team will respond to your ticket soon.</p>
        </div>
      </div>

      <div class="reply-section" *ngIf="canReply()">
        <div class="reply-header">
          <button
            class="toggle-reply-btn"
            (click)="toggleReplyForm()"
            [class.active]="showReplyForm"
          >
            <svg
              *ngIf="!showReplyForm"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
              ></path>
            </svg>
            <svg
              *ngIf="showReplyForm"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            <span>{{ showReplyForm ? "Cancel Reply" : "Add Reply" }}</span>
          </button>
        </div>

        <div class="reply-form-container" *ngIf="showReplyForm">
          <form [formGroup]="replyForm" (ngSubmit)="submitReply()">
            <div class="form-group">
              <label for="replyMessage">Your Reply</label>
              <textarea
                id="replyMessage"
                formControlName="message"
                class="reply-textarea"
                [class.invalid]="
                  replyForm.get('message')?.invalid &&
                  replyForm.get('message')?.touched
                "
                placeholder="Type your reply here..."
                rows="6"
              ></textarea>
              <div class="textarea-footer">
                <div class="character-count">
                  {{ getCharacterCount() }} /
                  {{ getMaxCharacters() }} characters
                </div>
                <div
                  class="error-message"
                  *ngIf="
                    replyForm.get('message')?.invalid &&
                    replyForm.get('message')?.touched
                  "
                >
                  <span *ngIf="replyForm.get('message')?.errors?.['required']">
                    Reply message is required
                  </span>
                  <span *ngIf="replyForm.get('message')?.errors?.['minlength']">
                    Reply must be at least 1 character long
                  </span>
                  <span *ngIf="replyForm.get('message')?.errors?.['maxlength']">
                    Reply cannot exceed 5000 characters
                  </span>
                </div>
              </div>
            </div>

            <div class="form-actions">
              <button
                type="button"
                class="cancel-btn"
                (click)="toggleReplyForm()"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="submit-reply-btn"
                [disabled]="replyForm.invalid || isLoadingReply"
              >
                <span *ngIf="!isLoadingReply">Send Reply</span>
                <span *ngIf="isLoadingReply" class="loading-content">
                  <span class="spinner"></span>
                  Sending...
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="ticket-closed-notice" *ngIf="!canReply()">
        <div class="notice-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>
        <h3>Ticket Closed</h3>
        <p>
          This ticket has been closed and no longer accepts replies. If you need
          further assistance, please create a new ticket.
        </p>
      </div>
    </div>

    <div class="loading-container" *ngIf="isLoading">
      <div class="loading-indicator">
        <div class="loading-spinner"></div>
        <p>Loading ticket details...</p>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
